import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0B0F14] border-t border-[#1F2933] py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo & About */}
          <div className="space-y-4">
            <img
              src="/logo.png"
              alt="The AI Kompany"
              className="h-20 w-auto"
            />
            <p className="text-base text-[#9CA3AF] font-['League_Spartan']">
              Automate & Scale Your Business With AI
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-['Qurova',sans-serif] font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan']"
                >
                  AI Automation
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan']"
                >
                  AI Consultation
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan']"
                >
                  Custom Development
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-['Qurova',sans-serif] font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan']"
                >
                  About Us
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('case-studies')}
                  className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan']"
                >
                  Case Studies
                </button>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan']"
                >
                  Blog
                </Link>
              </li>

            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-['Qurova',sans-serif] font-semibold mb-4">Get In Touch</h4>
            <div className="space-y-2">
              <a
                href="mailto:enquiry@theaikompany.com"
                className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan'] flex items-center group"
              >
                <ArrowRight className="w-3 h-3 mr-2 group-hover:translate-x-1 transition-transform duration-200" />
                Email Us
              </a>
              {/*<a
                href="http://www.theaikompany.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan'] flex items-center group"
              >
                <ArrowRight className="w-3 h-3 mr-2 group-hover:translate-x-1 transition-transform duration-200" />
                Visit Website
              </a>*/}
              <a
                onClick={() => scrollToSection('contact')}
                className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan'] flex items-center group"
              >
                <ArrowRight className="w-3 h-3 mr-2 group-hover:translate-x-1 transition-transform duration-200" />
                Contact Us
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#1F2933] pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-base text-[#9CA3AF] font-['League_Spartan']">
            © 2026 The AI Kompany. All rights reserved.
          </p>
          {/*<div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan']">
              Privacy Policy
            </a>
            <a href="#" className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200 font-['League_Spartan']">
              Terms of Service
            </a>
          </div>*/}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
